const VideoPlayer = ({
  videoSource,
  label,
  sourceField,
  onEnded,
}: {
  videoSource: string;
  label: string;
  sourceField?: string;
  onEnded: () => void;
}) => (
  <div className="gallery-video" data-tina-field={sourceField}>
    <video aria-label={label} controls playsInline preload="metadata" onEnded={onEnded}>
      <source src={videoSource} type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  </div>
);

export default VideoPlayer;
